import { db, timestamp } from "../firebase";

export default {
  state: {
    courses: []
  },

  mutations: {
    setCourses(state, courses) {
      state.courses = courses;
    },
    clearCourses(state) {
      state.courses = [];
    }
  },

  actions: {
    async fetchAllCourses({ commit }) {
      try {
        const snapshot = await db.collection("courses").get();

        const docs = [];
        snapshot.docs.forEach(doc => {
          docs.push(doc.data());
        });

        commit("setCourses", docs);
        return docs;
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async fetchCourseById({ commit, getters }, courseId) {
      // Permission check
      if (!getters.employee) {
        commit("setError", "unauthorized");
        return;
      }

      try {
        let course = await db
          .collection("courses")
          .doc(courseId)
          .get();

        course = course.data();
        commit("setEditorContent", course.desc);

        return course;
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async deleteCourseById({ commit, getters }, courseId) {
      // Permission check
      if (!getters.employee) {
        commit("setError", "unauthorized");
        return;
      }

      try {
        await db
          .collection("courses")
          .doc(courseId)
          .delete();

        commit("setError", "form/deleted");
        return;
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async submitCourse({ commit, getters }, course) {
      // Permission check
      if (!getters.employee) {
        commit("setError", "unauthorized");
        return;
      }

      try {
        const { email } = getters.user;
        if (course.courseId) {
          await db
            .collection("courses")
            .doc(course.courseId)
            .update({
              updatedBy: email,
              updatedAt: timestamp,
              ...course
            });
          commit("setError", "form/updated");
        } else {
          const ref = db.collection("courses").doc();
          const id = ref.id;
          await ref.set({
            createdBy: email,
            createdAt: timestamp,
            courseId: id,
            ...course
          });
          commit("setError", "form/submitted");
        }
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    }
  },

  getters: {
    courses: s => s.courses,
    getCourseById: s => id => {
      return s.courses.find(c => c.courseId === id);
    }
  }
};
